  // tslint:disable
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { GenProvider } from 'providers/gen/gen';

@Injectable()
export class MessagingService {
  parametro : any;
  messaging = firebase.messaging()
  currentMessage = new BehaviorSubject(null)

  constructor( private afAuth: AngularFireAuth, private genProvider: GenProvider) {
   // console.log ("Ativar Notificações Push")
   }


  updateToken(token, grupo, path) {
    this.afAuth.authState.take(1).subscribe(user => {
      if (!user) return;
      const data = {
        userId:user.uid,
        grupoId: grupo,
        token : token
      }
      this.genProvider.onSaveDocKey('dados/' + path + '/devices', data.token, data);
    })
  }

  getPermission(grupo, path) {
    this.messaging.requestPermission()
      .then(() => {
        console.log('Permissão de notificação concedida.');
        return this.messaging.getToken()
      })
      .then(token => {
    //    console.log(token)
        this.updateToken(token, grupo, path)
      })
      .catch((err) => {
        console.log('Não foi possível obter permissão para notificação.', err);
      });
  }

  receiveMessage() {
    this.messaging.onMessage((payload) => {
      console.log("Mensagem recebida.", payload);
      this.currentMessage.next(payload)
    });

  }
}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/messaging.service.ts